(() => {
  const getRoot = (node) => (node && node.querySelectorAll ? node : document);
  window.EurusUpsellSelections = window.EurusUpsellSelections || {};
  window.EurusUpsellBackgroundMode = true;
  let originalUpcartOpenOnAddToCart;
  let upcartEnforceTimer;
  let atcPriceSyncFrame = 0;
  let atcPriceSyncTimeout = 0;
  window.EurusAtcPriceCharsByButton = window.EurusAtcPriceCharsByButton || {};
  window.EurusAllowCartInteractionUntil = Number(window.EurusAllowCartInteractionUntil || 0);
  window.EurusUpsellSyncFlushers = window.EurusUpsellSyncFlushers || [];
  window.EurusFlushUpsellSync = window.EurusFlushUpsellSync || (() => {
    (window.EurusUpsellSyncFlushers || []).forEach((flushFn) => {
      try {
        if (typeof flushFn === 'function') {
          flushFn();
        }
      } catch (error) {
        console.error(error);
      }
    });
  });

  const setSuppressUntil = (ms) => {
    const now = Date.now();
    const current = Number(window.EurusMiniCartSuppressUntil || 0);
    window.EurusMiniCartSuppressUntil = Math.max(current, now + ms);
  };

  const getUpcartSettings = () => {
    if (!window.upcartSettings || !window.upcartSettings.upcartSettings) {
      return null;
    }
    return window.upcartSettings.upcartSettings;
  };

  const forceUpcartOpenOnAddToCart = (enabled) => {
    const settings = getUpcartSettings();
    if (!settings) {
      return false;
    }

    if (typeof originalUpcartOpenOnAddToCart === 'undefined') {
      originalUpcartOpenOnAddToCart = Boolean(settings.openOnAddToCart);
    }

    settings.openOnAddToCart = Boolean(enabled);
    return true;
  };

  const shouldSuppressCartOpen = () => {
    if (Date.now() < Number(window.EurusAllowCartInteractionUntil || 0)) {
      return false;
    }
    return window.EurusSuppressMiniCartOpen === true || Date.now() < Number(window.EurusMiniCartSuppressUntil || 0);
  };

  const syncUpcartSuppression = () => {
    if (shouldSuppressCartOpen()) {
      forceUpcartOpenOnAddToCart(false);
      return;
    }
    if (typeof originalUpcartOpenOnAddToCart !== 'undefined') {
      forceUpcartOpenOnAddToCart(originalUpcartOpenOnAddToCart);
    }
  };

  const ensureUpcartSuppressionWatcher = () => {
    if (upcartEnforceTimer) {
      return;
    }

    upcartEnforceTimer = window.setInterval(() => {
      syncUpcartSuppression();
      if (!shouldSuppressCartOpen()) {
        window.clearInterval(upcartEnforceTimer);
        upcartEnforceTimer = null;
      }
    }, 120);
  };

  const releaseCartOpenSuppression = () => {
    window.EurusSuppressMiniCartOpenCount = 0;
    window.EurusSuppressMiniCartOpen = false;
    window.EurusMiniCartSuppressUntil = 0;
    syncUpcartSuppression();
    if (upcartEnforceTimer) {
      window.clearInterval(upcartEnforceTimer);
      upcartEnforceTimer = null;
    }
  };

  const startSilentUpsellMutation = () => {
    window.EurusSuppressMiniCartOpenCount = (window.EurusSuppressMiniCartOpenCount || 0) + 1;
    window.EurusSuppressMiniCartOpen = true;
    setSuppressUntil(1800);
    syncUpcartSuppression();
    ensureUpcartSuppressionWatcher();
  };

  const stopSilentUpsellMutation = () => {
    window.EurusSuppressMiniCartOpenCount = Math.max(0, (window.EurusSuppressMiniCartOpenCount || 0) - 1);
    setSuppressUntil(800);
    syncUpcartSuppression();
    ensureUpcartSuppressionWatcher();
    if (window.EurusSuppressMiniCartOpenCount === 0) {
      setTimeout(() => {
        if (window.EurusSuppressMiniCartOpenCount === 0 && Date.now() >= Number(window.EurusMiniCartSuppressUntil || 0)) {
          window.EurusSuppressMiniCartOpen = false;
          syncUpcartSuppression();
        }
      }, 850);
    }
  };

  const guardMiniCartOpen = () => {
    if (typeof Alpine === 'undefined' || !Alpine.store) return;
    const miniCartStore = Alpine.store('xMiniCart');
    if (!miniCartStore || miniCartStore.__seUpsellWrapped) return;

    const originalOpenCart = miniCartStore.openCart.bind(miniCartStore);
    const originalReloadCart = typeof miniCartStore.reLoad === 'function'
      ? miniCartStore.reLoad.bind(miniCartStore)
      : null;
    miniCartStore.openCart = function(...args) {
      if (window.EurusSuppressMiniCartOpen === true) return;
      if (Date.now() < Number(window.EurusMiniCartSuppressUntil || 0)) return;
      return originalOpenCart(...args);
    };
    if (originalReloadCart) {
      miniCartStore.reLoad = function(...args) {
        if (window.EurusSuppressMiniCartOpen === true) return;
        if (Date.now() < Number(window.EurusMiniCartSuppressUntil || 0)) return;
        return originalReloadCart(...args);
      };
    }
    miniCartStore.__seUpsellWrapped = true;
  };

  document.addEventListener('alpine:init', () => {
    setTimeout(guardMiniCartOpen, 0);
    setTimeout(syncUpcartSuppression, 0);
  });
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(guardMiniCartOpen, 0);
    setTimeout(syncUpcartSuppression, 0);
    document.addEventListener('click', (event) => {
      const cartTrigger = event.target && event.target.closest
        ? event.target.closest('#cart-icon, .header-icon-cart, [aria-controls="CartDrawer"], #mobile-cart-icon-bubble, #cart-icon-bubble, #cart-icon-bubble-mobile-dock')
        : null;
      if (cartTrigger) {
        window.EurusAllowCartInteractionUntil = Date.now() + 1500;
        releaseCartOpenSuppression();
        return;
      }

      const target = event.target && event.target.closest
        ? event.target.closest('[id^="x-atc-button-"], .add_to_cart_button[name="add"]')
        : null;
      if (!target) {
        return;
      }
      if (typeof window.EurusFlushUpsellSync === 'function') {
        window.EurusFlushUpsellSync();
      }
      releaseCartOpenSuppression();
    }, true);
  });

  const isUpsellLine = (line) => {
    const properties = line && line.properties ? line.properties : {};
    return String(properties._upsell_item || '') === 'true';
  };

  const getUpsellParentProductId = (line) => {
    const properties = line && line.properties ? line.properties : {};
    return String(properties._upsell_parent_product || '');
  };

  const belongsToCurrentProductUpsell = (line, currentProductId) => {
    if (!isUpsellLine(line)) return false;
    const parentId = getUpsellParentProductId(line);
    // Do not bind legacy parent-less upsell lines to the current product UI.
    if (!parentId) return false;
    return parentId === String(currentProductId || '');
  };

  const loadCart = async () => {
    const response = await fetch(`${Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) {
      throw new Error('Unable to load cart.');
    }
    return response.json();
  };

  const addUpsellItem = async (variantId, quantity, productId) => {
    startSilentUpsellMutation();
    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js?se_upsell=1`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Eurus-Upsell': '1'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: Number(quantity),
              properties: {
                _upsell_item: 'true',
                _upsell_parent_product: String(productId || '')
              }
            }
          ]
        })
      });
      if (!response.ok) {
        throw new Error('Unable to add upsell item.');
      }
      return response.json();
    } finally {
      stopSilentUpsellMutation();
    }
  };

  const changeLineQuantity = async (lineKey, quantity) => {
    startSilentUpsellMutation();
    try {
      const response = await fetch(`${Shopify.routes.root}cart/change.js?se_upsell=1`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Eurus-Upsell': '1'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: Number(quantity)
        })
      });
      if (!response.ok) {
        throw new Error('Unable to update upsell quantity.');
      }
      return response.json();
    } finally {
      stopSilentUpsellMutation();
    }
  };

  const dispatchCartState = () => {
    if (typeof window.upcartRegisterAddToCart === 'function') {
      try {
        window.upcartRegisterAddToCart();
      } catch (error) {
        console.error(error);
      }
    }

    if (typeof Alpine !== 'undefined' && Alpine.store && Alpine.store('xMiniCart')) {
      Alpine.store('xMiniCart').reLoad();
      if (window.EurusSuppressMiniCartOpen !== true) {
        Alpine.store('xMiniCart').openCart();
      }
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    scheduleAtcPriceSync(0);
  };

  const loadUpsellLines = async (productId, variantId) => {
    const cart = await loadCart();
    const matchingLines = (cart.items || []).filter((line) => {
      return (
        String(line && line.variant_id) === String(variantId) &&
        belongsToCurrentProductUpsell(line, productId)
      );
    });
    return { cart, matchingLines };
  };

  const setUpsellVariantQuantity = async (productId, variantId, desiredQty) => {
    const quantity = Math.max(0, Number(desiredQty) || 0);
    const { matchingLines } = await loadUpsellLines(productId, variantId);
    const [primary, ...duplicates] = matchingLines;
    let lastPayload = null;

    for (const line of duplicates) {
      lastPayload = await changeLineQuantity(line.key, 0);
    }

    if (!primary) {
      if (quantity > 0) {
        lastPayload = await addUpsellItem(variantId, quantity, productId);
      }
      return lastPayload;
    }

    lastPayload = await changeLineQuantity(primary.key, quantity);
    return lastPayload;
  };

  const getCurrentUpsellVariantQuantity = async (productId, variantId) => {
    const { matchingLines } = await loadUpsellLines(productId, variantId);
    return matchingLines.reduce((total, line) => total + Math.max(0, Number(line && line.quantity) || 0), 0);
  };

  const updateUpsellVariantQuantity = async (variantId, desiredQty) => {
    const quantity = Math.max(0, Number(desiredQty) || 0);
    const updates = {};
    updates[String(variantId)] = quantity;

    startSilentUpsellMutation();
    try {
      const response = await fetch(`${Shopify.routes.root}cart/update.js?se_upsell=1`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Eurus-Upsell': '1'
        },
        body: JSON.stringify({
          updates
        })
      });
      if (!response.ok) {
        throw new Error('Unable to update upsell quantity with update.js.');
      }
      return response.json();
    } finally {
      stopSilentUpsellMutation();
    }
  };

  const getCurrencyCode = () => {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return '';
  };

  const parseMoneyToCents = (rawValue) => {
    const compactValue = String(rawValue || '').replace(/\s+/g, '');
    if (!compactValue) {
      return NaN;
    }

    const moneyTokenMatch = compactValue.match(/-?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{1,2})?|-?\d+(?:[.,]\d{1,2})?/);
    if (!moneyTokenMatch) {
      return NaN;
    }

    const value = moneyTokenMatch[0];
    if (!value) {
      return NaN;
    }

    const lastComma = value.lastIndexOf(',');
    const lastDot = value.lastIndexOf('.');
    let decimalSeparator = '';
    if (lastComma > -1 && lastDot > -1) {
      decimalSeparator = lastComma > lastDot ? ',' : '.';
    } else if (lastComma > -1 || lastDot > -1) {
      const candidateSeparator = lastComma > -1 ? ',' : '.';
      const matches = value.match(new RegExp(`\\${candidateSeparator}`, 'g')) || [];
      const separatorIndex = value.lastIndexOf(candidateSeparator);
      const digitsAfter = value.length - separatorIndex - 1;
      if (digitsAfter > 0 && digitsAfter <= 2) {
        decimalSeparator = candidateSeparator;
      } else if (matches.length === 1 && digitsAfter !== 3) {
        decimalSeparator = candidateSeparator;
      }
    }

    let normalized = value;
    if (decimalSeparator) {
      const separatorIndex = normalized.lastIndexOf(decimalSeparator);
      const integerPart = normalized.slice(0, separatorIndex).replace(/[.,]/g, '');
      const fractionPart = normalized.slice(separatorIndex + 1).replace(/[.,]/g, '');
      normalized = `${integerPart}.${fractionPart}`;
    } else {
      normalized = normalized.replace(/[,.]/g, '');
    }

    normalized = normalized.replace(/(?!^)-/g, '');
    const amount = Number.parseFloat(normalized);
    if (!Number.isFinite(amount)) {
      return NaN;
    }
    return Math.round(amount * 100);
  };

  const formatMoney = (cents, samplePriceText = '') => {
    const amount = Number(cents) / 100;
    const sample = String(samplePriceText || '').trim();
    if (sample) {
      const decimalWithComma = /,\d{1,2}\b/.test(sample);
      const formattedAmount = amount.toFixed(2);
      const localizedAmount = decimalWithComma ? formattedAmount.replace('.', ',') : formattedAmount;
      const prefixMatch = sample.match(/^[^\d-]+/);
      if (prefixMatch) {
        return `${prefixMatch[0]}${localizedAmount}`;
      }
      const suffixMatch = sample.match(/[^\d]+$/);
      if (suffixMatch) {
        return `${localizedAmount}${suffixMatch[0]}`;
      }
      return localizedAmount;
    }

    const currencyCode = getCurrencyCode();
    if (currencyCode) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currencyCode
        }).format(amount);
      } catch (error) {
        // Continue to lightweight formatting fallback.
      }
    }

    return amount.toFixed(2);
  };

  const getAtcScope = (button) => {
    const productScope = button.closest('.product-info, .product__info-wrapper, [data-product-form], [id^="ProductSection-"]');
    if (productScope) {
      return productScope;
    }
    return (
      button.closest('.x-block-buy-buttons, .choose-option-footer, .shopify-section') ||
      button.closest('form[action*="/cart/add"]') ||
      document
    );
  };

  const getUpsellListForScope = (scope) => {
    if (!scope) {
      return null;
    }
    if (scope.querySelector) {
      const localList = scope.querySelector('[data-upsell-list]');
      if (localList) {
        return localList;
      }
    }
    const sectionScope = scope.closest && scope.closest('.shopify-section, [id^="shopify-section-"]');
    if (sectionScope && sectionScope.querySelector) {
      return sectionScope.querySelector('[data-upsell-list]');
    }
    return null;
  };

  const getUpsellTotalCents = (scope) => {
    const list = getUpsellListForScope(scope);
    if (!list) {
      return 0;
    }

    return [...list.querySelectorAll('[data-upsell-item]')].reduce((total, item) => {
      const unitPrice = Number(item.dataset.upsellPriceCents || 0);
      const quantity = Number(item.dataset.selectedQty || 0);
      if (!Number.isFinite(unitPrice) || !Number.isFinite(quantity) || quantity <= 0) {
        return total;
      }
      return total + unitPrice * quantity;
    }, 0);
  };

  const getKachingSelectedPriceNode = (scope) => {
    if (!scope || !scope.querySelector) {
      return null;
    }
    return (
      scope.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price') ||
      scope.querySelector('.kaching-bundles__bar input[type="radio"]:checked + label .kaching-bundles__bar-price') ||
      null
    );
  };

  const getBasePriceNode = (scope, button = null) => {
    if (button && button.querySelector) {
      const buttonPriceNode =
        button.querySelector('.main-product-price .price-sale') ||
        button.querySelector('.main-product-price .price-item--sale') ||
        button.querySelector('.main-product-price .price-item--regular') ||
        button.querySelector('.main-product-price .price span') ||
        button.querySelector('.main-product-price .price');
      if (buttonPriceNode) {
        return buttonPriceNode;
      }
    }

    return (
      scope.querySelector('[data-product-price]') ||
      scope.querySelector('.main-product-price .price-sale') ||
      scope.querySelector('.main-product-price .price-item--sale') ||
      scope.querySelector('.main-product-price .price-item--regular') ||
      scope.querySelector('.main-product-price .price span') ||
      scope.querySelector('.main-product-price .price') ||
      scope.querySelector('.x-block-price .price-item--sale') ||
      scope.querySelector('.x-block-price .price-item--regular') ||
      scope.querySelector('.x-block-price .price-item') ||
      scope.querySelector('.price .price-item--sale') ||
      scope.querySelector('.price .price-item--regular') ||
      scope.querySelector('.price .price-item') ||
      null
    );
  };

  const parseIntegerString = (value) => {
    const cleanValue = String(value || '').trim();
    if (!/^-?\d+$/.test(cleanValue)) {
      return NaN;
    }
    return Number.parseInt(cleanValue, 10);
  };

  const getBasePriceCents = (scope, button, basePriceNode) => {
    const basePriceText = String((basePriceNode && basePriceNode.textContent) || '').trim();
    const parsedBasePrice = parseMoneyToCents(basePriceText);
    if (Number.isFinite(parsedBasePrice)) {
      return parsedBasePrice;
    }

    const buttonTargetPriceNode = button && button.querySelector ? button.querySelector('.main-product-price .target-price') : null;
    const buttonTargetPrice = parseIntegerString(buttonTargetPriceNode && buttonTargetPriceNode.textContent);
    if (Number.isFinite(buttonTargetPrice)) {
      return buttonTargetPrice;
    }

    const scopeTargetPriceNode = scope && scope.querySelector ? scope.querySelector('.main-product-price .target-price') : null;
    const scopeTargetPrice = parseIntegerString(scopeTargetPriceNode && scopeTargetPriceNode.textContent);
    if (Number.isFinite(scopeTargetPrice)) {
      return scopeTargetPrice;
    }

    return NaN;
  };

  const ensureAtcPriceStyles = () => {
    if (document.getElementById('se-atc-price-styles')) {
      return;
    }
    const style = document.createElement('style');
    style.id = 'se-atc-price-styles';
    style.textContent = `
      .se-atc-text-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        width: 100%;
      }
      .se-atc-price {
        display: inline-block;
        text-align: left;
      }
    `;
    document.head.appendChild(style);
  };

  const getAtcPriceSlotChars = (scope) => {
    if (!scope || !scope.querySelectorAll) {
      return 8;
    }
    const texts = [
      ...scope.querySelectorAll('.kaching-bundles__bar-price, .kaching-bundles__bar-full-price, [data-product-price], .price .price-item')
    ]
      .map((node) => String(node.textContent || '').trim())
      .filter(Boolean);
    if (!texts.length) {
      return 8;
    }
    const longest = texts.reduce((max, text) => Math.max(max, text.length), 0);
    return Math.max(8, longest);
  };

  const isProductPage = () => {
    return (
      (document.body && document.body.classList.contains('template-product')) ||
      window.location.pathname.includes('/products/')
    );
  };

  const getUpsellBlockMarkerForScope = (scope) => {
    if (!scope) {
      return null;
    }
    if (scope.querySelector) {
      const localMarker = scope.querySelector('[data-upsell-items-block]');
      if (localMarker) {
        return localMarker;
      }
    }
    const sectionScope = scope.closest && scope.closest('.shopify-section, [id^="shopify-section-"]');
    if (sectionScope && sectionScope.querySelector) {
      return sectionScope.querySelector('[data-upsell-items-block]');
    }
    return document.querySelector('[data-upsell-items-block]');
  };

  const shouldShowAtcPricePart = (scope) => {
    if (!isProductPage()) {
      return false;
    }
    return Boolean(getUpsellBlockMarkerForScope(scope) || getUpsellListForScope(scope));
  };

  const restoreAtcLabel = (button, labelNode) => {
    if (!labelNode) {
      return;
    }

    if (button.dataset.seAtcOriginalHtml) {
      if (labelNode.innerHTML !== button.dataset.seAtcOriginalHtml) {
        labelNode.innerHTML = button.dataset.seAtcOriginalHtml;
      }
    } else if (button.dataset.seAtcBaseLabel) {
      const nextText = String(button.dataset.seAtcBaseLabel);
      if (labelNode.textContent !== nextText) {
        labelNode.textContent = nextText;
      }
    }
    labelNode.classList.remove('se-atc-text-wrap');
  };

  const renderAtcLabel = (button, labelNode, baseLabel, priceText) => {
    if (!labelNode) {
      return;
    }

    if (!button.dataset.seAtcOriginalHtml) {
      button.dataset.seAtcOriginalHtml = labelNode.innerHTML;
    }

    ensureAtcPriceStyles();
    labelNode.classList.add('se-atc-text-wrap');

    let labelPart = labelNode.querySelector('[data-se-atc-label]');
    let pricePart = labelNode.querySelector('[data-se-atc-price]');
    if (!labelPart || !pricePart) {
      labelNode.textContent = '';
      labelPart = document.createElement('span');
      labelPart.setAttribute('data-se-atc-label', 'true');
      pricePart = document.createElement('span');
      pricePart.setAttribute('data-se-atc-price', 'true');
      pricePart.className = 'se-atc-price';
      labelNode.appendChild(labelPart);
      labelNode.appendChild(pricePart);
    }

    const nextPriceText = String(priceText || button.dataset.seAtcLastPriceText || '\u00A0');
    if (labelPart.textContent !== baseLabel) {
      labelPart.textContent = baseLabel;
    }
    if (pricePart.textContent !== nextPriceText) {
      pricePart.textContent = nextPriceText;
    }
    if (priceText) {
      button.dataset.seAtcLastPriceText = String(priceText);
    }
    const cacheKey = String(button.id || button.dataset.seAtcBaseLabel || '');
    const currentChars = Number(button.dataset.seAtcPriceChars || 0);
    const cachedChars = Number(window.EurusAtcPriceCharsByButton[cacheKey] || 0);
    const lockedChars = Number(button.dataset.seAtcPriceCharsLocked || 0);
    const nextChars = Math.max(currentChars, cachedChars, lockedChars, String(nextPriceText).length, 8);
    button.dataset.seAtcPriceChars = String(nextChars);
    if (cacheKey) {
      window.EurusAtcPriceCharsByButton[cacheKey] = nextChars;
    }
    const nextWidth = `${nextChars}ch`;
    if (pricePart.style.minWidth !== nextWidth) {
      pricePart.style.minWidth = nextWidth;
    }
  };

  const syncAtcButtonPrice = (button) => {
    const labelNode = button.querySelector('.x-atc-text') || button;
    if (!labelNode) {
      return;
    }

    if (!button.dataset.seAtcBaseLabel) {
      button.dataset.seAtcBaseLabel = String(labelNode.textContent || '').replace(/\s+/g, ' ').trim();
    }

    const scope = getAtcScope(button);
    if (!shouldShowAtcPricePart(scope)) {
      restoreAtcLabel(button, labelNode);
      return;
    }

    const isAvailable = button.getAttribute('data-available') === 'true' && !button.disabled;
    if (!isAvailable) {
      renderAtcLabel(button, labelNode, button.dataset.seAtcBaseLabel, button.dataset.seAtcLastPriceText || '');
      return;
    }

    if (!button.dataset.seAtcPriceCharsLocked) {
      button.dataset.seAtcPriceCharsLocked = String(getAtcPriceSlotChars(scope));
    }
    const hasKachingBars = Boolean(scope.querySelector && scope.querySelector('.kaching-bundles__bar-price'));
    const previousBasePriceCents = Number(button.dataset.seAtcBasePriceCents || 0);
    const previousBasePriceSample = String(button.dataset.seAtcBasePriceSample || button.dataset.seAtcLastPriceText || '');
    let basePriceText = '';
    let basePriceCents = NaN;

    if (hasKachingBars) {
      const selectedKachingPriceNode = getKachingSelectedPriceNode(scope);
      const selectedKachingPriceText = String((selectedKachingPriceNode && selectedKachingPriceNode.textContent) || '').trim();
      const selectedKachingPriceCents = parseMoneyToCents(selectedKachingPriceText);
      if (Number.isFinite(selectedKachingPriceCents) && selectedKachingPriceCents > 0) {
        basePriceText = selectedKachingPriceText;
        basePriceCents = selectedKachingPriceCents;
        button.dataset.seAtcBasePriceCents = String(basePriceCents);
        button.dataset.seAtcBasePriceSample = basePriceText;
      } else if (Number.isFinite(previousBasePriceCents) && previousBasePriceCents > 0) {
        basePriceText = previousBasePriceSample;
        basePriceCents = previousBasePriceCents;
      } else {
        return;
      }
    } else {
      const basePriceNode = getBasePriceNode(scope, button);
      if (!basePriceNode) {
        return;
      }
      basePriceText = String(basePriceNode.textContent || '').trim();
      basePriceCents = getBasePriceCents(scope, button, basePriceNode);
      if (!Number.isFinite(basePriceCents) || basePriceCents <= 0) {
        return;
      }
    }

    const upsellTotalCents = getUpsellTotalCents(scope);
    const fullPriceText = formatMoney(basePriceCents + upsellTotalCents, basePriceText);
    renderAtcLabel(button, labelNode, button.dataset.seAtcBaseLabel, fullPriceText);
  };

  const scheduleAtcPriceSync = (delay = 0) => {
    const upsellAtcLockUntil = Number(window.EurusUpsellAtcLockUntil || 0);
    if (delay > 0 && Date.now() < upsellAtcLockUntil) {
      return;
    }
    if (delay > 0) {
      window.clearTimeout(atcPriceSyncTimeout);
      atcPriceSyncTimeout = window.setTimeout(() => {
        scheduleAtcPriceSync(0);
      }, delay);
      return;
    }
    if (atcPriceSyncFrame) {
      return;
    }
    atcPriceSyncFrame = window.requestAnimationFrame(() => {
      atcPriceSyncFrame = 0;
      document.querySelectorAll('[id^="x-atc-button-"]').forEach((button) => syncAtcButtonPrice(button));
    });
  };

  const initAtcPriceSync = () => {
    if (document.__seAtcPriceSyncReady) {
      scheduleAtcPriceSync(0);
      return;
    }
    document.__seAtcPriceSyncReady = true;

    const relevantSelector = [
      '[id^="x-atc-button-"]',
      '[data-upsell-list]',
      '[name="id"]',
      '[name="selling_plan"]',
      '[id^="update-variant-"]',
      '.kaching-bundles__bar',
      '.kaching-bundles__bar-price'
    ].join(', ');

    const isInsideFreeTier = (node) => {
      if (!node || !node.closest) return false;
      return Boolean(node.closest('[id^="free-tier-"], .x-block-free-product-tier, .free-tier-offer'));
    };

    document.addEventListener('change', (event) => {
      if (isInsideFreeTier(event.target)) return;
      const target = event.target && event.target.closest ? event.target.closest(relevantSelector) : null;
      if (target) {
        scheduleAtcPriceSync(40);
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (isInsideFreeTier(event.target)) return;
      const isUpsellControl = event.target && event.target.closest
        ? event.target.closest('[data-upsell-add], [data-upsell-minus], [data-upsell-plus]')
        : null;
      if (isUpsellControl) {
        return;
      }
      const target = event.target && event.target.closest
        ? event.target.closest('.kaching-bundles__bar, [id^="x-atc-button-"]')
        : null;
      if (target) {
        scheduleAtcPriceSync(80);
      }
    }, true);

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver((mutations) => {
        const shouldSync = mutations.some((mutation) => {
          const rawTarget = mutation.target && mutation.target.nodeType === 3
            ? mutation.target.parentElement
            : mutation.target;
          if (isInsideFreeTier(rawTarget)) return false;
          return Boolean(rawTarget && rawTarget.closest && rawTarget.closest(relevantSelector));
        });
        if (shouldSync) {
          scheduleAtcPriceSync(40);
        }
      });
      observer.observe(document.body, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'value', 'disabled', 'data-available']
      });
    }

    scheduleAtcPriceSync(0);
  };

  const getUpsellSelectedQuantity = (list) => {
    if (!list || !list.querySelectorAll) {
      return 0;
    }
    return [...list.querySelectorAll('[data-upsell-item]')].reduce((total, item) => {
      const quantity = Number(item.dataset.selectedQty || 0);
      if (!Number.isFinite(quantity) || quantity <= 0) {
        return total;
      }
      return total + quantity;
    }, 0);
  };

  const updateFreeTierProgress = (tierEl, quantity) => {
    if (!tierEl) {
      return;
    }
    const steps = [...tierEl.querySelectorAll('.ft-item')];
    if (!steps.length) {
      return;
    }

    const normalizedQty = Math.max(0, Number(quantity) || 0);
    const activeIndex = normalizedQty >= 3 ? 2 : normalizedQty >= 2 ? 1 : normalizedQty >= 1 ? 0 : -1;

    steps.forEach((step, index) => {
      const isActive = index <= activeIndex;
      step.classList.toggle('ft-item--active', isActive);
      if (index === activeIndex && activeIndex >= 0) {
        step.setAttribute('aria-current', 'step');
      } else {
        step.removeAttribute('aria-current');
      }
    });

    const progress = tierEl.querySelector('.ft-progress');
    if (progress) {
      const progressScale = normalizedQty >= 3 ? 1 : normalizedQty >= 2 ? 0.5 : 0;
      progress.style.transform = `scaleX(${progressScale})`;
    }
  };

  const syncFreeTierWithUpsellList = (list) => {
    if (!list) {
      return;
    }
    const quantity = getUpsellSelectedQuantity(list);
    const scope =
      list.closest('.product-info, .product__info-wrapper, [data-product-form], [id^="ProductSection-"]') ||
      list.closest('.shopify-section') ||
      document;
    scope.querySelectorAll('.x-block-free-product-tier .free-tier-offer').forEach((tierEl) => {
      updateFreeTierProgress(tierEl, quantity);
    });
  };

  const resetUpsellCountUI = (scope) => {
    if (!scope || !scope.querySelectorAll) {
      return;
    }
    scope.querySelectorAll('[data-upsell-count]').forEach((countEl) => {
      countEl.textContent = '1';
    });
  };

  const initUpsellList = (list) => {
    if (!list || list.__upsellReady) {
      return;
    }
    list.__upsellReady = true;

    const hiddenInput = list.querySelector('[data-upsell-items-json]');
    const productId = list.dataset.upsellProductId;
    if (!hiddenInput) {
      return;
    }

    const state = {};
    const itemByVariantId = {};
    const pendingByVariantId = {};
    const needsResyncByVariantId = {};
    const debouncedSyncTimersByVariantId = {};
    const lastSyncedQuantityByVariantId = {};
    const UPSELL_SYNC_DEBOUNCE_MS = 220;

    const syncState = () => {
      const payload = Object.keys(state)
        .map((variantId) => ({
          id: Number(variantId),
          quantity: Number(state[variantId])
        }))
        .filter((item) => Number.isFinite(item.id) && Number.isFinite(item.quantity) && item.quantity > 0);

      if (window.EurusUpsellBackgroundMode) {
        hiddenInput.value = '[]';
        if (productId) {
          window.EurusUpsellSelections[productId] = [];
        }
        return [];
      }

      hiddenInput.value = JSON.stringify(payload);
      if (productId) {
        window.EurusUpsellSelections[productId] = payload;
      }

      return payload;
    };

    const setControlBusy = (item, busy) => {
      if (!item || !item.querySelectorAll) {
        return;
      }
      item.querySelectorAll('[data-upsell-add], [data-upsell-minus], [data-upsell-plus]').forEach((button) => {
        if (button.matches('[data-upsell-add]')) {
          // Important: theme.css has `button[aria-disabled="true"]{display:none}`.
          // Never toggle aria-disabled on ADD for temporary busy state.
          button.removeAttribute('aria-disabled');
          button.toggleAttribute('data-se-busy', Boolean(busy));
          button.style.pointerEvents = busy ? 'none' : '';
          return;
        }
        button.disabled = Boolean(busy);
      });
    };

    const bindActivator = (element, callback) => {
      element.addEventListener('click', (event) => {
        if (element.disabled || element.getAttribute('aria-disabled') === 'true') {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        callback();
      });
      element.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        if (element.disabled || element.getAttribute('aria-disabled') === 'true') {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        callback();
      });
    };

    const setQuantityUI = (item, variantId, nextQty) => {
      const addButton = item.querySelector('[data-upsell-add]');
      const qtyWrapper = item.querySelector('[data-upsell-qty]');
      const countEl = item.querySelector('[data-upsell-count]');
      if (!addButton || !qtyWrapper || !countEl) {
        return;
      }

      const quantity = Math.max(0, Number(nextQty) || 0);
      item.dataset.selectedQty = String(quantity);

      if (quantity === 0) {
        delete state[variantId];
        item.classList.remove('is-selected');
        // Show target control first to avoid a transient frame where both are hidden.
        addButton.hidden = false;
        qtyWrapper.hidden = true;
        countEl.textContent = '1';
        if (addButton.hidden) addButton.hidden = false;
        if (!qtyWrapper.hidden) qtyWrapper.hidden = true;
        syncState();
        scheduleAtcPriceSync(0);
        syncFreeTierWithUpsellList(list);
        return;
      }

      state[variantId] = quantity;
      item.classList.add('is-selected');
      countEl.textContent = String(quantity);
      // Show target control first to avoid transient blank action area.
      qtyWrapper.hidden = false;
      addButton.hidden = true;
      if (qtyWrapper.hidden) qtyWrapper.hidden = false;
      if (!addButton.hidden) addButton.hidden = true;
      syncState();
      scheduleAtcPriceSync(0);
      syncFreeTierWithUpsellList(list);
    };

    const syncVariantQuantityNow = async (item, variantId) => {
      if (!variantId || !productId) {
        return;
      }
      if (pendingByVariantId[variantId]) {
        needsResyncByVariantId[variantId] = true;
        return;
      }

      const desiredQuantity = Math.max(0, Number(state[variantId] || 0));
      const lastSyncedQuantity = Math.max(0, Number(lastSyncedQuantityByVariantId[variantId] || 0));
      if (desiredQuantity === lastSyncedQuantity) {
        return;
      }

      pendingByVariantId[variantId] = true;

      try {
        await setUpsellVariantQuantity(productId, variantId, desiredQuantity);
        const syncedQuantity = await getCurrentUpsellVariantQuantity(productId, variantId);
        if (syncedQuantity !== desiredQuantity) {
          await setUpsellVariantQuantity(productId, variantId, desiredQuantity);
        }
        lastSyncedQuantityByVariantId[variantId] = desiredQuantity;
      } catch (error) {
        console.error(error);
        const rollbackQuantity = Math.max(0, Number(lastSyncedQuantityByVariantId[variantId] || 0));
        setQuantityUI(item, variantId, rollbackQuantity);
      } finally {
        pendingByVariantId[variantId] = false;
        const nextDesiredQuantity = Math.max(0, Number(state[variantId] || 0));
        const nextSyncedQuantity = Math.max(0, Number(lastSyncedQuantityByVariantId[variantId] || 0));
        const shouldResync = needsResyncByVariantId[variantId] || nextDesiredQuantity !== nextSyncedQuantity;
        if (shouldResync) {
          needsResyncByVariantId[variantId] = false;
          syncVariantQuantityNow(itemByVariantId[variantId], variantId);
        }
      }
    };

    const queueDebouncedVariantSync = (item, variantId) => {
      window.clearTimeout(debouncedSyncTimersByVariantId[variantId]);
      debouncedSyncTimersByVariantId[variantId] = window.setTimeout(() => {
        delete debouncedSyncTimersByVariantId[variantId];
        syncVariantQuantityNow(item, variantId);
      }, UPSELL_SYNC_DEBOUNCE_MS);
    };

    const flushPendingVariantSyncs = () => {
      Object.keys(debouncedSyncTimersByVariantId).forEach((variantId) => {
        window.clearTimeout(debouncedSyncTimersByVariantId[variantId]);
        delete debouncedSyncTimersByVariantId[variantId];
        syncVariantQuantityNow(itemByVariantId[variantId], variantId);
      });
    };

    if (!list.__upsellFlushRegistered) {
      list.__upsellFlushRegistered = true;
      window.EurusUpsellSyncFlushers.push(flushPendingVariantSyncs);
    }

    const getDisplayedQuantity = (item) => {
      if (!item) {
        return 0;
      }
      const fromDataset = Number(item.dataset.selectedQty || 0);
      if (Number.isFinite(fromDataset)) {
        return Math.max(0, fromDataset);
      }
      const countEl = item.querySelector('[data-upsell-count]');
      const fromCount = Number(countEl ? countEl.textContent : 0);
      if (Number.isFinite(fromCount)) {
        return Math.max(0, fromCount);
      }
      return 0;
    };

    const applyQuantity = (item, variantId, nextQty) => {
      if (!variantId) {
        return;
      }

      const quantity = Math.max(0, Number(nextQty) || 0);
      const currentQuantity = getDisplayedQuantity(item);
      if (quantity === currentQuantity) {
        return;
      }
      window.EurusUpsellAtcLockUntil = Date.now() + 550;
      setQuantityUI(item, variantId, quantity);
      if (window.EurusUpsellBackgroundMode) {
        queueDebouncedVariantSync(item, variantId);
      }
    };

    if (productId) {
      window.EurusUpsellSelections[productId] = [];
    }

    list.querySelectorAll('[data-upsell-item]').forEach((item) => {
      const variantId = item.dataset.variantId;
      const addButton = item.querySelector('[data-upsell-add]');
      const qtyWrapper = item.querySelector('[data-upsell-qty]');
      const minusButton = item.querySelector('[data-upsell-minus]');
      const plusButton = item.querySelector('[data-upsell-plus]');
      const countEl = item.querySelector('[data-upsell-count]');

      if (!variantId || !addButton || !qtyWrapper || !minusButton || !plusButton || !countEl) {
        return;
      }
      itemByVariantId[variantId] = item;

      bindActivator(addButton, () => {
        const currentQty = getDisplayedQuantity(item);
        applyQuantity(item, variantId, currentQty + 1);
      });
      minusButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        const currentQty = getDisplayedQuantity(item);
        applyQuantity(item, variantId, currentQty - 1);
      });
      plusButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        const currentQty = getDisplayedQuantity(item);
        applyQuantity(item, variantId, currentQty + 1);
      });

      setQuantityUI(item, variantId, 0);
    });

    scheduleAtcPriceSync(0);
    syncFreeTierWithUpsellList(list);
  };

  const initUpsellLists = (rootNode) => {
    getRoot(rootNode).querySelectorAll('[data-upsell-list]').forEach((list) => {
      initUpsellList(list);
    });
  };

  const UPSELL_MODAL_ANIMATION_MS = 280;
  const isUpsellInfoMobile = () => window.matchMedia('(max-width: 767px)').matches;

  const hasOpenOverlay = () =>
    document.querySelector('[data-icon-popup-overlay][aria-hidden="false"], [data-upsell-modal][aria-hidden="false"]');

  const openUpsellInfoModal = (modal) => {
    if (!modal || !isUpsellInfoMobile()) return;
    if (modal.__upsellModalCloseTimer) {
      clearTimeout(modal.__upsellModalCloseTimer);
      modal.__upsellModalCloseTimer = null;
    }
    modal.classList.remove('is-closing');
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'true');
    requestAnimationFrame(() => {
      modal.setAttribute('aria-hidden', 'false');
    });
    document.body.classList.add('overflow-hidden');
    window.dispatchEvent(new CustomEvent('vm:overlay:open'));
  };

  const closeUpsellInfoModal = (modal) => {
    if (!modal) return;
    if (modal.__upsellModalCloseTimer) {
      clearTimeout(modal.__upsellModalCloseTimer);
      modal.__upsellModalCloseTimer = null;
    }
    modal.classList.add('is-closing');
    modal.setAttribute('aria-hidden', 'true');
    modal.__upsellModalCloseTimer = setTimeout(() => {
      modal.hidden = true;
      modal.style.display = 'none';
      modal.classList.remove('is-closing');
      modal.__upsellModalCloseTimer = null;
      if (!hasOpenOverlay()) {
        document.body.classList.remove('overflow-hidden');
      }
    }, UPSELL_MODAL_ANIMATION_MS);
  };

  const addUpsellFromModal = (variantId) => {
    if (!variantId) return;
    const escapedVariantId = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(String(variantId)) : String(variantId);
    const item = document.querySelector(`[data-upsell-item][data-variant-id="${escapedVariantId}"]`);
    if (!item) return;

    const selectedQty = Number(item.dataset.selectedQty || 0);
    const addButton = item.querySelector('[data-upsell-add]');
    const plusButton = item.querySelector('[data-upsell-plus]');
    if (selectedQty > 0 && plusButton) {
      plusButton.click();
      return;
    }
    if (addButton) {
      addButton.click();
    }
  };

  const bindUpsellInfoModalHandlers = () => {
    if (document.__upsellInfoModalHandlersBound) return;
    document.__upsellInfoModalHandlersBound = true;

    document.addEventListener(
      'click',
      (event) => {
        const openTrigger = event.target && event.target.closest
          ? event.target.closest('[data-upsell-info-open]')
          : null;
        if (openTrigger) {
          event.preventDefault();
          event.stopPropagation();
          const modalId = openTrigger.getAttribute('data-upsell-info-open');
          if (!modalId) return;
          openUpsellInfoModal(document.getElementById(modalId));
          return;
        }

        const closeTrigger = event.target && event.target.closest
          ? event.target.closest('[data-upsell-modal-close]')
          : null;
        if (closeTrigger) {
          event.preventDefault();
          event.stopPropagation();
          closeUpsellInfoModal(closeTrigger.closest('[data-upsell-modal]'));
          return;
        }

        const addTrigger = event.target && event.target.closest
          ? event.target.closest('[data-upsell-modal-add]')
          : null;
        if (addTrigger) {
          event.preventDefault();
          event.stopPropagation();
          if (addTrigger.disabled || addTrigger.getAttribute('aria-disabled') === 'true') {
            return;
          }
          addUpsellFromModal(addTrigger.getAttribute('data-upsell-variant-id'));
          closeUpsellInfoModal(addTrigger.closest('[data-upsell-modal]'));
          return;
        }

        const overlay = event.target && event.target.matches && event.target.matches('[data-upsell-modal]')
          ? event.target
          : null;
        if (overlay) {
          closeUpsellInfoModal(overlay);
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-upsell-modal][aria-hidden="false"]').forEach((modal) => {
        closeUpsellInfoModal(modal);
      });
    });
  };

  const initUpsellInfoModal = (rootNode) => {
    bindUpsellInfoModalHandlers();
    const root = getRoot(rootNode);
    root.querySelectorAll('[data-upsell-modal]').forEach((modal) => {
      if (modal.getAttribute('aria-hidden') !== 'false') {
        modal.hidden = true;
        modal.style.display = 'none';
      }
    });
  };

  const openIconPopup = (overlay) => {
    if (!overlay) return;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.hidden = false;
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    window.dispatchEvent(new CustomEvent('vm:overlay:open'));
  };

  const closeIconPopup = (overlay) => {
    if (!overlay) return;
    overlay.hidden = true;
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    if (!hasOpenOverlay()) {
      document.body.classList.remove('overflow-hidden');
    }
  };

  const bindIconPopupGlobalHandlers = () => {
    if (document.__iconPopupGlobalHandlersBound) return;
    document.__iconPopupGlobalHandlersBound = true;

    document.addEventListener(
      'click',
      (event) => {
        const closeButton = event.target && event.target.closest
          ? event.target.closest('[data-icon-popup-close]')
          : null;
        if (closeButton) {
          event.preventDefault();
          event.stopPropagation();
          const overlay = closeButton.closest('[data-icon-popup-overlay]');
          closeIconPopup(overlay);
          return;
        }

        const overlay = event.target && event.target.matches && event.target.matches('[data-icon-popup-overlay]')
          ? event.target
          : null;
        if (overlay) {
          closeIconPopup(overlay);
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-icon-popup-overlay][aria-hidden="false"]').forEach((overlay) => {
        closeIconPopup(overlay);
      });
    });
  };

  const initIconPopup = (rootNode) => {
    const root = getRoot(rootNode);
    bindIconPopupGlobalHandlers();
    root.querySelectorAll('[data-icon-popup-open]').forEach((trigger) => {
      if (trigger.__iconPopupBound) return;
      trigger.__iconPopupBound = true;

      const overlayId = trigger.getAttribute('data-icon-popup-open');
      const resolveOverlay = () =>
        document.getElementById(overlayId) ||
        document.getElementById('vm-overlay') ||
        document.querySelector('.vm-overlay,[data-vm-overlay]');

      trigger.addEventListener('click', (event) => {
        if (trigger.closest('.icon-popup-card__img-wrap')) {
          event.stopPropagation();
        }
        openIconPopup(resolveOverlay());
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (trigger.closest('.icon-popup-card__img-wrap')) {
          event.stopPropagation();
        }
        openIconPopup(resolveOverlay());
      });
    });

    root.querySelectorAll('[data-icon-popup-overlay]').forEach((overlay) => {
      if (overlay.__iconPopupOverlayBound) return;
      overlay.__iconPopupOverlayBound = true;
      if (overlay.getAttribute('aria-hidden') !== 'false') {
        overlay.hidden = true;
        overlay.style.display = 'none';
      }

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          closeIconPopup(overlay);
        }
      });

      overlay.querySelectorAll('[data-icon-popup-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          closeIconPopup(overlay);
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initUpsellLists(document);
    initUpsellInfoModal(document);
    initIconPopup(document);
    initAtcPriceSync();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initUpsellLists(event.target);
    initUpsellInfoModal(event.target);
    initIconPopup(event.target);
    initAtcPriceSync();
  });
})();
